var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st-container",class:`theme${_vm.kindTheme}`,attrs:{"id":"st-container"}},[_c('NavMenu'),_c('ContentWrapper'),((_vm.currentPage==='home' || _vm.currentPage === 'search-result') && !_vm.isFCLAgent)?_c('bottom-left-call'):_vm._e(),(_vm.currentPage==='home')?_c('bottom-right-call-info'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }